// extracted by mini-css-extract-plugin
export var container = "_5f-0";
export var disabled = "_5f-4";
export var fullWidth = "_5f-3";
export var lined = "_5f-1";
export var selected = "_5f-5";
export var tab = "_5f-2";